import { useMutation } from "@tanstack/react-query";
import { paymentApi, TossPaymentsPlanUpgradeConfirmType } from "api/paymentApi";

export function useConfirmTossPaymentsPlanUpgrade() {
  return useMutation(
    // 토스 결제 성공 API
    async (payload: TossPaymentsPlanUpgradeConfirmType) => {
      const response = await paymentApi.confirmTossPaymentsPlanUpgrade(payload);
      // 비즈니스 실패(미확정 + 실패 메시지)인 경우 에러로 처리하여 onSuccess 흐름을 막는다.
      if (
        response?.result?.isConfirmed !== true &&
        response?.result?.failureMessage
      ) {
        throw new Error(response.result.failureMessage as string);
      }
      return response;
    },
    {
      onSuccess: async (responseData, variables) => {},
      onError: (error: unknown) => {
        const message =
          (error && typeof error === "object" && "message" in error
            ? (error as any).message
            : undefined) || "결제가 실패했어요. 다시 시도해 주세요.";
        alert(message);
      },
    }
  );
}
